<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M7.54541 13.0001H18.5454" stroke="currentColor" />
    <circle cx="13.0454" cy="13.0001" r="10" stroke="currentColor" />
  </svg>
</template>
